var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgFormatGeneric = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 18 21",
    fill: "currentColor",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.833.5H1a.5.5 0 0 0-.5.5v19.167a.5.5 0 0 0 .5.5h15.833a.5.5 0 0 0 .5-.5V6a.5.5 0 0 0-.146-.354l-5-5A.5.5 0 0 0 11.833.5Zm-.207 1 4.707 4.707v13.459H1.5V1.5h10.126Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.978 9.51a.5.5 0 0 1 .885.013l.033.086 2.084 7.083a.5.5 0 0 1-.399.635l-.081.006H5.167a.5.5 0 0 1-.479-.646l.031-.077 2.084-4.167a.5.5 0 0 1 .73-.188l.07.058 1.194 1.193 2.18-3.995Zm.299 1.539-1.921 3.524a.5.5 0 0 1-.725.171l-.068-.057-1.176-1.177-1.412 2.823h6.856l-1.554-5.284ZM11.333 1a.5.5 0 0 1 .788-.41l.066.056 5 5a.5.5 0 0 1-.268.847l-.086.007h-5a.5.5 0 0 1-.492-.41L11.333 6V1Zm1 1.207V5.5h3.293l-3.293-3.293ZM6.417 6.333a1.75 1.75 0 1 0 0 3.5 1.75 1.75 0 0 0 0-3.5Zm0 1a.75.75 0 1 1 0 1.5.75.75 0 0 1 0-1.5Z"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgFormatGeneric);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/format-generic.84bb3ee6a6ccc37140719e3cd3f543e2.svg";